import { useGetQuery, useRouteParams } from "@quortex/front-common"

export declare type PlayPoolListParams = {
  orgUuid?: string
  contentSteeringEnabled?: string
}

//--------------------------------------------------------------------------------------------------
// URLs
//--------------------------------------------------------------------------------------------------

/** @returns /play_pools/?org=${orgUuid} */
const getPlayPoolListUrl = ({ orgUuid, contentSteeringEnabled }: Required<PlayPoolListParams>) =>
  `/play_pools/?org=${orgUuid}${contentSteeringEnabled ? `&content_steering_enabled=${contentSteeringEnabled}` : ""}`

//--------------------------------------------------------------------------------------------------
// Queries & mutations
//--------------------------------------------------------------------------------------------------

export const usePlayPoolList = (params?: PlayPoolListParams) => {
  const mergedParams = useRouteParams(params)
  const listUrl = getPlayPoolListUrl(mergedParams)

  return useGetQuery<api.switchns.PlayPool[]>("switch", listUrl)
}
